import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";

const labelText = {
  fontWeight: 400,
  fontSize: "14px",
  fontFamily: `'Roboto', sans-serif`,
  color: "#002856",
};

export const AmountDetailsSummary = () => {
  const { summary } = useNewSubscriberContext();

  const {
    ContributionAmount,
    POPCharges,
    REGCharges,
    ServiceTax,
    TotalCharges,
    T2Amount,
  } = summary?.data?.serviceCharges || {};

  return (
    <>
      <div className="new-subscriber-container">
        <div
          style={{
            paddingLeft: "16px",
            fontSize: "18px",
            color: "#000000",
            fontWeight: "400",
            opacity: "0.8",
            paddingBottom: "4px",
          }}
        >
          AMOUNT PAYABLE
        </div>
      </div>
      <div
        style={{
          // display: "grid",
          // gridTemplateColumns: "1fr 1fr 1fr 1fr",
          // justifySelf: "auto",
          display: "flex",
          justifyContent: "space-between",
          // border: "1px solid gray",
          padding: "15px",
          // marginTop: "30px",
          marginBottom: "0px",
        }}
        className="container-margin"
      >
        <div>
          <p style={labelText}>Contribution Amount (Tier I)</p>
          {T2Amount ? (
            <p style={labelText}>Contribution Amount (Tier I & II)</p>
          ) : null}

          <p style={labelText}>POP Charges</p>
          <p style={labelText}>Payment Gateway Charges</p>
          <p style={labelText}>GST</p>
        </div>
        <div>
          <p>₹ {parseFloat(ContributionAmount)?.toLocaleString("en-IN")}</p>
          {T2Amount ? (
            <p>₹ {parseFloat(T2Amount)?.toLocaleString("en-IN")}</p>
          ) : null}

          <p>₹ {POPCharges}</p>
          <p>₹ {REGCharges}</p>
          <p>₹ {ServiceTax}</p>
        </div>
      </div>
      <div
        style={{
          background: "#F6F6F8",
          display: "flex",
          justifyContent: "space-between",
          textAlign: "center",
          color: "#000000",
          fontSize: "15px",
          fontFamily: `'Roboto', sans-serif`,
          padding: "10px 50px 0px 50px",
          // padding: "10px",
          // marginLeft: "50px",
          // marginRight: "50px",
          // marginBottom: "40px",
        }}
      >
        <p style={{ marginLeft: "10px" }}>Amount Payable</p>
        <p>₹ {parseFloat(TotalCharges)?.toLocaleString("en-IN")}</p>
      </div>
    </>
  );
};
